<template>
  <footer class="footer">
    <a
      class="footer__link"
      @click.prevent="newPage()"
      @mouseenter="cursorToScroll"
      @mouseleave="cursorToClose"
    >
      <div class="footer__button"><span>›</span></div>
      <div class="footer__year">{{ data.nextYear }}</div>
      <div class="footer__title">{{ data.nextTitle }}</div>
      <div class="footer__line-container">
        <p>Next</p>
        <span class="footer__line"></span>
      </div>
    </a>
    <div class="footer__content">
      <p>
        <a
          href="https://thefwa.com/cookie-policy"
          traget="_blank"
          rel="noopener"
          @mouseenter="cursorToScroll"
          @mouseleave="cursorToClose"
        >Cookie</a> . <a
          href="https://thefwa.com/privacy-statement"
          traget="_blank"
          rel="noopener"
          @mouseenter="cursorToScroll"
          @mouseleave="cursorToClose"
        >Privacy </a>
        — © 2019 <a
          href="https://thefwa.com/"
          traget="_blank"
          rel="noopener"
          @mouseenter="cursorToScroll"
          @mouseleave="cursorToClose"
        >The FWA</a>
      </p>
    </div>
  </footer>
</template>

<script>
import { TweenMax, Power3 } from 'gsap/TweenMaxBase';


export default {
  name: 'PageFooter',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  methods: {
    newPage() {
      TweenMax.to(this.$el.parentNode, 1, { y: -200, autoAlpha: 0, ease: Power3.easeInOut });
      this.$eventHub.$emit('navigateTo', this.data.nextYear);
    },
    cursorToScroll() {
      this.$eventHub.$emit('cursorToZoom');
      this.$eventHub.$emit('soundInteraction');
    },
    cursorToClose() {
      if (!this.$store.state.scrollIsLocked) {
        this.$eventHub.$emit('cursorToClose');
      } else {
        this.$eventHub.$emit('cursorToScroll');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  width: 100%;

  padding: 80px 20px 0;

  @include mq(ipadL) {
    padding: 40px 15.625vw 45px;

    display: flex;
    align-items: baseline;
    justify-content: space-between;
  }

  &__link {
    text-align: center;
    cursor: pointer;

    > div {
      display: block;

      @include mq(ipadL) {
        display: inline-block;
      }
    }
  }

  &__line-container {
    margin-left: 40px;

    @include mq($until: ipadL) {
      @include visually-hidden;
    }

    @include mq($and: $is-not-touch-device) {
      &:hover .footer__line::before {
        width: 100%;
      }
    }
  }

  &__line {
    display: block;
    position: relative;
    width: 90px;
    height: 5px;
    margin-bottom: 4px;

    border-radius: 3px;
    background-color: rgba($color-black, 0.1);

    overflow: hidden;

    &::before {
      content: '';

      position: absolute;
      top: 0;
      left: 0;
      width: 0;
      height: 100%;

      background-color: $color-primary;
      border-radius: 3px;
      transform-origin: 0% 50%;
      transition: width 0.3s $inOutQuint;
    }
  }

  &__year {
    font-size: font-size(xxs);

    @include mq(ipadL) {
      font-size: font-size(xl);
    }
  }

  &__title {
    font-size: font-size(l);
    height: 65px;
    margin-top: 20px;

    @include mq(ipadL) {
      @include visually-hidden;
    }
  }

  &__content {
    @include mq($until: ipadL) {
      @include visually-hidden;
    }

    transform: translateY(-10px);
  }

  p {
    display: inline-block;
    font-size: font-size(xxs);
  }

  &__button {
    position: relative;
    padding: 15px;
    margin-bottom: 30px;

    background-image: url('/img/svg/cursor.svg');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;

    @include mq(ipadL) {
      @include visually-hidden;
    }

    span {
      display: inline-block;
      transform-origin: 50% 45%;
      transform: rotate(90deg);
    }
  }

  .footer__content a {
    position: relative;

    &::before {
      content: '';

      position: absolute;
      bottom: -2px;
      left: 0;
      width: 100%;
      height: 1px;

      background-color: $color-text;
      transform-origin: 0% 50%;
      transition: transform 0.5s $inOutQuint;
      transform: scaleX(0);
    }

    @include mq($and: $is-not-touch-device) {
      &:hover::before {
        transform: scaleX(1);
      }
    }
  }
}
</style>
